import { Injectable } from '@angular/core';
import { FormValueModel } from '@domain/dynamic-form';

@Injectable()
export class PopulateFormFieldsService {
	public constructor() {}

	public setFormValue(
		formValue: FormValueModel,
		fieldName: string,
		fieldValue: string | number | boolean
	): FormValueModel {
		return {
			...formValue,
			[fieldName]: fieldValue
		};
	}
}
